import React from 'react';
import CircularLoading, { CircularProgressProps } from '@mui/material/CircularProgress';

type Props = CircularProgressProps & {
    size?: number
    noStyles?: boolean
};

// We need to take the grid container and grid item off here to make this more atomic design friendly
const Loading: React.FC<Props> = ({ noStyles, color = 'primary', size = 36, ...props }) => {
    return (
        !noStyles ? <CircularLoading color={color} size={size} {...props}
            sx={{ position: 'absolute'}}
            style={{
                top: `calc(50% - ${size / 2}px)`,
                left: `calc(50% - ${size / 2}px)`
            }} /> : <CircularLoading color={color} size={size} {...props}
        />
    )
}

export default Loading;
